const clip = (value, max = 40) => String(value || '').replace(/[<>]/g, '').trim().slice(0, max);

const readHighEntropyHints = async () => {
    try {
        const uaData = navigator.userAgentData;
        if (!uaData?.getHighEntropyValues) return null;
        const values = await uaData.getHighEntropyValues(['platform', 'model']);
        const brand = (uaData.brands || []).find((item) => (
            item?.brand && !/not.?a.?brand|chromium/i.test(item.brand)
        ));
        return {
            mobile: uaData.mobile,
            platform: values?.platform || uaData.platform,
            browser: brand?.brand,
        };
    } catch {
        return null;
    }
};

const parseUserAgent = (ua = '', hints = null) => {
    const source = String(ua || '');
    let deviceType = 'desktop';
    if (hints?.mobile === true || /mobi|iphone|ipod|android.+mobile|windows phone/i.test(source)) {
        deviceType = 'mobile';
    } else if (/ipad|tablet|playbook|silk/i.test(source)) {
        deviceType = 'tablet';
    }

    let browser = clip(hints?.browser);
    if (!browser) {
        if (/edg(e|a|ios)?\//i.test(source)) browser = 'Edge';
        else if (/opr\/|opera/i.test(source)) browser = 'Opera';
        else if (/samsungbrowser/i.test(source)) browser = 'Samsung Internet';
        else if (/chrome\/|crios\//i.test(source) && !/edg/i.test(source)) browser = 'Chrome';
        else if (/firefox\/|fxios\//i.test(source)) browser = 'Firefox';
        else if (/safari/i.test(source) && !/chrome|crios|android/i.test(source)) browser = 'Safari';
        else browser = 'Desconocido';
    }

    let os = clip(hints?.platform);
    if (!os) {
        if (/windows phone/i.test(source)) os = 'Windows Phone';
        else if (/windows/i.test(source)) os = 'Windows';
        else if (/android/i.test(source)) os = 'Android';
        else if (/iphone|ipad|ipod/i.test(source)) os = 'iOS';
        else if (/mac os x|macintosh/i.test(source)) os = 'macOS';
        else if (/cros/i.test(source)) os = 'ChromeOS';
        else if (/linux/i.test(source)) os = 'Linux';
        else os = 'Desconocido';
    }

    if (os === 'macOS' && deviceType === 'mobile') os = 'iOS';

    return {
        browser: clip(browser) || 'Desconocido',
        os: clip(os) || 'Desconocido',
        deviceType,
        mobile: deviceType !== 'desktop',
    };
};

let cachedDevice = null;

export const getDeviceInfo = () => {
    if (cachedDevice) return cachedDevice;
    if (typeof navigator === 'undefined') {
        return { browser: 'Desconocido', os: 'Desconocido', deviceType: 'desktop', mobile: false };
    }

    const uaData = navigator.userAgentData;
    const hints = uaData
        ? {
            mobile: uaData.mobile,
            platform: uaData.platform,
            browser: (uaData.brands || []).find((item) => (
                item?.brand && !/not.?a.?brand|chromium/i.test(item.brand)
            ))?.brand,
        }
        : null;

    cachedDevice = parseUserAgent(navigator.userAgent || '', hints);
    readHighEntropyHints().then((better) => {
        if (!better) return;
        cachedDevice = parseUserAgent(navigator.userAgent || '', {
            ...hints,
            ...better,
        });
    }).catch(() => {});

    return cachedDevice;
};
